import { PageHeader } from '../ui';
import { useBinder } from '../../lib/useBinder';
import { useRunStore } from '../../store/runStore';
import { useUiStore } from '../../store/uiStore';
import { api, type CompendiumDetail, type CompendiumType } from '../../api/client';
import { CompendiumBrowser } from '../views/CompendiumBrowser';
import { srdToLocal } from '../../lib/srdImport';
import { listEntitiesOf, nextEntityId } from '../../lib/entityBuckets';

/** SRD compendium reference + import into the running adventure's bestiary/items. */
export function CompendiumSection() {
  const ctx = useBinder();
  const refreshAdventure = useRunStore((s) => s.refreshAdventure);
  const toast = useUiStore((s) => s.toast);
  if (!ctx) return null;
  const { adventure, slug } = ctx;

  const importEntry = async (
    kind: 'beast' | 'item',
    detail: CompendiumDetail,
    type: CompendiumType,
  ) => {
    try {
      const local = srdToLocal(type, detail);
      const existing = listEntitiesOf(adventure, kind);
      const id = nextEntityId(existing, String(local.name ?? 'voce'));
      await api.createEntity(slug, kind, { id, ...local });
      await refreshAdventure();
      toast(
        `"${String(local.name)}" importato in ${kind === 'beast' ? 'Bestiario' : 'Oggetti'}`,
        'success',
      );
    } catch {
      toast('Import non riuscito', 'danger');
    }
  };

  return (
    <div>
      <PageHeader eyebrow="Compendio" title="Riferimento SRD" />
      <CompendiumBrowser
        onImport={importEntry}
        hint="I mostri vengono importati nel Bestiario; equipaggiamento e oggetti magici negli Oggetti."
      />
    </div>
  );
}
